import { render } from "./HistoricoPropostas.vue?vue&type=template&id=333b9f30"
import script from "./HistoricoPropostas.vue?vue&type=script&lang=js"
export * from "./HistoricoPropostas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__